import React, {useState, useEffect, useRef} from 'react';
import {
  Box,
  TableContainer,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Table,
  TableCaption,
  Tfoot,
  IconButton,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Button,
  Flex,
  Input,
  Heading,
  Spacer,
  FormLabel,
} from '@chakra-ui/react';
import LoadingWheel from '../../components/General/LoadingWheel';
import {get, post} from '../../service/ApiService';
import {Department} from '../../service/Urls';
import {FaSave, FaPlusCircle, FaSearch} from 'react-icons/fa';
import {PageButtons, pageButtons, setGrid} from '../../helpers/SetGrid';
import ErrorHelper from '../../service/ErrorHelper';
import {useTitle} from '../../components/General/Layout';

// [{id: 'MB9J60jOPQqm', rgId: 1000, rgDesc: 'Hillsborough'}]
const DepartmentMaintenance = props => {
  const [departmentData, setDepartmentData] = useState([]);
  const [toast, setToast] = useState({});
  // const [forDelete, setForDelete] = useState({id: '', regionName: ''});
  const [elements, setElements] = useState({body: {}, header: {}, footer: {}});
  const [isLoading, setLoading] = useState(true);
  const [title, setTitle] = useTitle('Department Maintenance');
  const [pages, setPages] = useState({
    pageNum: 1,
    totalPages: 5,
    itemsPerPage: 8,
    getNewPage: curPage => {
      loadData(curPage);
    },
  });

  // These two will hold/update the state of any new Regions that are added
  const [newId, setNewId] = useState('');
  const [newDesc, setNewDesc] = useState('');

  // These two will hold/update the state of search fields
  const [searchId, setSearchId] = useState('');
  const [searchDesc, setSearchDesc] = useState('');

  const {isOpen, onOpen, onClose} = useDisclosure();

  // useRef will save this across renders so it's not reloaded every time
  // to add more fields to the table, simply add their name and type to this json
  // if a new type is added you'll have to update the table to reflect that type (ie. dropdown or button)
  const visibleData = useRef({dpCode: 'text', dpDesc: 'text'});

  // Initial load of the page
  useEffect(() => {
    loadData(1);
  }, []);

  const loadData = async curPage => {
    let data = '';
    data = await get(Department.LIST + `?Page=${curPage}&PageSize=${pages.itemsPerPage}&DpCode=${searchId}&DpDesc=${searchDesc}`);
    setToast(data);
    if (!data.error) {
      setDepartmentData(data.data);
      // updates just one variable while keeping the state of the old ones
      setPages(prevState => ({
        ...prevState,
        totalPages: data.pageCount > 0 ? data.pageCount : 1,
        pageNum: curPage,
      }));
      setLoading(false);
      setTitle('Department Maintenance');
    }
  };

  // // Need this to repopulate everything on the UI any time the page number or data from the web changes
  // useEffect(() => {
  //   // this all isn't needed, only the footer of elements is used and I didn't want to copy all the paging logic to this file
  //   // setGrid(visibleData, regionData, pages, setElements);
  //   PageButtons(pages);
  // }, [regionData, pages]);

  // if no regionId is passed in, we'll assume we're adding.
  const add = (regionId = null) => {
    onOpen();
  };

  // If updating pass in the npk, otherwise adding can do without
  const save = async (id, desc, npk = null) => {
    let route = '';
    let successMessage = 'Success';

    if (npk != null) {
      route = Department.UPDATE + '/' + npk;
      successMessage = 'Successfully updated region ' + desc;
    } else {
      route = Department.ADD;
      successMessage = 'Successfully added new region ' + desc;
    }

    const response = await post(route, {rgId: id, description: desc, npk});
    // setSearchDesc(desc);
    setToast({response: response, successMessage: successMessage});
    onClose();
    loadData(pages.pageNum);
  };

  // const setForDeletion = id => {
  //   const regionName = regionData.filter(region => region.id == id);
  //   setForDelete({id: id, regionName: regionName[0].regionName});
  //   onOpen();
  // };

  // const deleteRegion = async () => {
  //   const data = await postDelete(Region.DELETE, `"${forDelete.id}"`);
  //   setToast({response: data, successMessage: 'SuccessFully deleted ' + forDelete.regionName, onSuccess: () => loadData(pages.pageNum)});
  //   onClose();
  // };

  const Row = ({region}) => {
    const [thisId, setThisId] = useState(region.dpCode ?? '');
    const [thisDesc, setThisDesc] = useState(region.dpDesc ?? '');
    return (
      <Tr>
        <Td>
          <Input value={thisId} onChange={e => setThisId(e.target.value)} w="50%" type="number" borderColor={'mint.300'} disabled />
        </Td>
        <Td>
          <Input value={thisDesc} onChange={e => setThisDesc(e.target.value)} w="50%" borderColor={'mint.300'} />
        </Td>
        <Td>
          <IconButton colorScheme="tertiary" title="Save" size="md" icon={<FaSave />} mr="2" onClick={() => save(thisId, thisDesc, region.id)} />
        </Td>
      </Tr>
    );
  };

  return (
    <>
      {isLoading ? (
        <>
          <LoadingWheel />
          <ErrorHelper toastResponse={toast} />
        </>
      ) : (
        <Box width={{base: '100%', lg: '85%'}}>
          <TableContainer>
            <Table border="solid 2px #0c5f78" variant="striped" colorScheme="mint">
              <TableCaption>Department Maintenance</TableCaption>
              <Thead>
                <Tr border="solid 2px #0c5f78">
                  <Th>
                    <Box>
                      <FormLabel htmlFor={'idSearch'} mb="-0.5" ml="1" fontSize="sm">
                        ID
                      </FormLabel>
                      <Input placeholder="ID" id={'idSearch'} w="50%" value={searchId} onChange={e => setSearchId(e.target.value)}></Input>
                    </Box>
                  </Th>
                  <Th>
                    <Flex>
                      <Box>
                        <FormLabel htmlFor={'descSearch'} mb="-0.5" ml="1" fontSize="sm">
                          Description
                        </FormLabel>
                        <Input placeholder="Description" id={'descSearch'} value={searchDesc} onChange={e => setSearchDesc(e.target.value)}></Input>
                      </Box>
                      <Spacer />
                      <Button rightIcon={<FaSearch />} colorScheme="tertiary" alignSelf="end" onClick={() => loadData(1)} ml="1.5">
                        Search
                      </Button>
                    </Flex>
                  </Th>
                  <Th>
                    <IconButton
                      icon={<FaPlusCircle />}
                      variant="outline"
                      colorScheme={'secondary'}
                      title="Add Region"
                      onClick={() => add()}
                      mb="-4"
                    />
                  </Th>
                </Tr>
              </Thead>
              <Tbody>
                {departmentData.map(region => {
                  return <Row key={region.id} region={region} />;
                })}
              </Tbody>
              <Tfoot>
                <Tr>
                  <Td />
                  <Td>
                    <PageButtons pages={pages} />
                  </Td>
                </Tr>
                {/* <Tr>{elements.footer}</Tr> */}
              </Tfoot>
            </Table>
          </TableContainer>

          {/** Modal window to add new regions */}
          <Modal isOpen={isOpen} onClose={onClose} motionPreset="slideInBottom" isCentered>
            <ModalOverlay />
            <ModalContent>
              <ModalHeader>
                <Heading size="lg">{'New Region'}</Heading>
              </ModalHeader>
              <ModalCloseButton />
              <ModalBody>
                <Box>
                  {/* <Flex mb="2">
                    <Heading size="md">ID: </Heading>
                    <Spacer />
                    <Input value={newId} onChange={e => setNewId(e.target.value)} w="50%" type="number" borderColor={'mint.300'} />
                  </Flex> */}

                  <Flex>
                    <Heading size="md">Description: </Heading>
                    <Spacer />
                    <Input value={newDesc} onChange={e => setNewDesc(e.target.value)} w="50%" borderColor={'mint.300'} />
                  </Flex>
                </Box>
              </ModalBody>

              <ModalFooter>
                <Button type="button" colorScheme="secondary" variant="outline" mr={3} onClick={() => save(newId, newDesc)}>
                  Save
                </Button>
              </ModalFooter>
            </ModalContent>
          </Modal>

          <ErrorHelper toastResponse={toast} />
        </Box>
      )}
    </>
  );
};

export default DepartmentMaintenance;
